<template>

  <div>

    <!-- visible in small devices -->
    <div v-if="isSmallDevice" class="pa-4 mb-5 d-flex" style="width:100%;">

      <v-app-bar flat color="white">

        <v-btn large icon class="mr-6" @click.stop="drawer = !drawer">
          <v-icon>mdi-menu</v-icon>
        </v-btn>

        <v-toolbar-title class="logo">{{ $t('main.home.' + appName + '.name') }}</v-toolbar-title>

        <div class="spacer"></div>

        <!-- Booking -->
        <v-btn v-if="isBookButtonVisible" outlined color="indigo" href="#book">
          <v-icon class="mr-2 indigo--text">mdi-bookmark</v-icon>
          {{ $t('main.header.book') }}
        </v-btn>
      </v-app-bar>

      <v-navigation-drawer v-model="drawer" absolute temporary width="80%">
        <v-list-item class="indigo lighten-1 py-6">
          <v-list-item-title class="logo white--text">{{ $t('main.home.' + appName + '.name') }}</v-list-item-title>
          <v-list-item-icon>
            <v-icon class="white--text" @click.stop="drawer = !drawer">mdi-close</v-icon>
          </v-list-item-icon>
        </v-list-item>

        <v-divider></v-divider>

        <v-list nav dense>

          <!-- Home -->
          <v-list-item link to="home" v-if="!hideButtons">
            <v-list-item-icon>
              <v-icon class="indigo--text">mdi-home</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>{{ $t('main.header.home') }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>

          <!-- Locale -->
          <v-list-group>
            <template v-slot:activator>
              <v-list-item-icon>
                <v-icon class="indigo--text">mdi-web</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title>{{ $t('main.header.languages') }}</v-list-item-title>
              </v-list-item-content>
            </template>

            <v-list-item v-for="loc in locales" :key="loc" link @click="changeLocale(loc)">
              <v-list-item-icon>
                <v-icon v-if="locale === loc">mdi-check</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title>{{ $t('shared.lang.' + loc) }}</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list-group>

          <!-- Currency -->
          <v-list-group>
            <template v-slot:activator>
              <v-list-item-icon>
                <v-icon class="indigo--text">mdi-currency-{{ currency.name }}</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title>{{ $t('main.header.currency') }}</v-list-item-title>
              </v-list-item-content>
            </template>


            <v-list-item v-for="curr in currencies" :key="curr.id" link @click="changeCurrency(curr)">
              <v-list-item-icon>
                <v-icon v-if="curr.name === currency.name">mdi-check</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title>{{ curr.name }}</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list-group>

          <!-- Login -->
          <v-list-item class="indigo" v-if="!loggedUser && !hideButtons" link to="login">
            <v-list-item-icon>
              <v-icon class="white--text">mdi-login</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title class="white--text">
                {{ $t('main.header.login') }}
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>

          <v-list-group v-if="loggedUser">
            <template v-slot:activator>
              <v-list-item-icon>
                <v-icon class="indigo--text">mdi-account-circle</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title>
                  {{ $t('main.header.myAccount') }}
                </v-list-item-title>
              </v-list-item-content>
            </template>

            <!-- user info -->
            <v-list-item>
              <v-list-item-avatar>
                <v-img src="https://randomuser.me/portraits/men/9.jpg"></v-img>
              </v-list-item-avatar>
              <v-list-item-content>
                <v-list-item-title>
                  {{ loggedUser.lastName }} {{ loggedUser.firstName }}
                </v-list-item-title>
                <v-list-item-subtitle>
                  {{ loggedUser.email }}
                </v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>

            <!-- account details -->
            <v-list-item link @click="$router.push('account')">
              <v-list-item-icon>
                <v-icon class="indigo--text">mdi-account-box-outline</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title>
                  {{ $t('main.header.accountDetails') }}
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>

            <!-- logout button -->
            <v-list-item class="red" link :disabled="isLoggingOut" @click="logout()">
              <v-list-item-icon>
                <v-icon class="white--text">mdi-logout</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title class="white--text">
                  {{ $t('main.header.logout') }}
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>

          </v-list-group>

        </v-list>

      </v-navigation-drawer>

    </div>


    <!-- visible in non small devices -->
    <v-app-bar v-if="!isSmallDevice" flat color="white">

      <div class="px-16 d-flex" style="width: 100vw;">

        <v-toolbar-title class="logo user-select-none"> {{ $t('main.home.' + appName + '.name') }}</v-toolbar-title>

        <div class="spacer"></div>

        <!-- Home -->
        <v-btn text color="indigo" class="black--text" to="home" v-if="!hideButtons">{{ $t('main.header.home') }}
        </v-btn>

        <!-- Locale -->
        <v-menu open-on-hover offset-y>
          <template v-slot:activator="{on, attrs}">
            <v-btn text color="indigo" class="black--text" v-bind="attrs" v-on="on">
              {{ $t('main.header.languages') }}
            </v-btn>
          </template>
          <v-list>
            <v-list-item v-for="loc in locales" :key="loc" link @click="changeLocale(loc)">
              <v-list-item-title>{{ $t('shared.lang.' + loc) }}</v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>

        <!-- Currency -->
        <v-menu open-on-hover offset-y>
          <template v-slot:activator="{on, attrs}">
            <v-btn color="indigo" text class="black--text" v-bind="attrs" v-on="on">
              {{ $t('main.header.currency') }} ({{ currency.name }})
            </v-btn>
          </template>
          <v-list>
            <v-list-item v-for="curr in currencies" :key="curr.id" link @click="changeCurrency(curr)">
              <v-list-item-title>{{ curr.name }}</v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>

        <!-- Booking -->
        <v-btn text color="indigo" class="black--text" href="#book" v-if="isBookButtonVisible">
          {{ $t('main.header.book') }}
        </v-btn>


        <!-- Login -->
        <v-btn color="indigo" class="white--text" href="#" v-if="!loggedUser && !hideButtons" link to="login">
          {{ $t('main.header.login') }}
        </v-btn>

        <v-btn text color="indigo" class="black--text" href="#" v-if="loggedUser && loggedUser.isAdmin"  @click="redirectToOldUi()">
          Administration (old UI)
        </v-btn>



        <!-- Account -->
        <v-menu bottom left v-if="loggedUser">
          <template v-slot:activator="{on, attrs}">
            <v-btn text color="indigo" class="black--text" v-bind="attrs" v-on="on">
              {{ $t('main.header.myAccount') }}
            </v-btn>
          </template>
          <v-list>
            <!-- user info -->
            <v-list-item>
              <v-list-item-avatar>
                <v-img src="https://randomuser.me/portraits/men/9.jpg"></v-img>
              </v-list-item-avatar>
              <v-list-item-content>
                <v-list-item-title>
                  {{ loggedUser.lastName }} {{ loggedUser.firstName }}
                </v-list-item-title>
                <v-list-item-subtitle>
                  {{ loggedUser.email }}
                </v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>

            <v-divider></v-divider>

            <v-list-item v-if="loggedUser.isAdmin" @click="redirectToOldUi()">
              <v-list-item-icon>
                <v-icon class="indigo--text">mdi-hamburger</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title>Administration</v-list-item-title>
              </v-list-item-content>
            </v-list-item>

            <!-- account details -->
            <v-list-item link to="account">
              <v-list-item-icon>
                <v-icon class="indigo--text">mdi-account-box-outline</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title>
                  {{ $t('main.header.accountDetails') }}
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <!-- logout -->
            <v-list-item class="red" :disabled="isLoggingOut" @click="logout()">
              <v-list-item-icon>
                <v-icon class="white--text">mdi-logout</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title class="white--text">
                  {{ $t('main.header.logout') }}
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </v-menu>

      </div>

    </v-app-bar>

  </div>

</template>

<script>
import { mapGetters } from 'vuex'
import { AuthApi } from '@/shared/services'
import { locales } from '@/shared/data'
import { ActivitiesApi } from '../services/api/activities'

export default {
  name: 'Header',
  data () {
    return {
      drawer: false,
      group: null,
      dialog: null,
      isBookButtonVisible: ['/home'].includes(this.$router.history.current.path),
      isLoggingOut: false,
      locales
    }
  },
  watch: {
    group () {
      this.drawer = false
    },
    $route (to, from) {
      this.isBookButtonVisible = ['home'].includes(to.name)
    }
  },
  methods: {
    redirectToOldUi () {
      if (process.env.NODE_ENV === 'production') {
        window.location.href = '/app/'
      } else {
        //local tests
        window.location.href = 'http://localhost:8080/app/'
      }
    },
    logout () {
      this.isLoggingOut = true
      AuthApi.logout()
          .then(() => {

            if (this.$route.path != '/home') {
              this.$router.push('home')
            }
            // clear auth from store
            commit('setAccessToken', null)
            commit('setLoggedUser', null)

          })
          .catch(error => this.$store.commit('main/setAlert', error))
          .finally(() => this.isLoggingOut = false)
    },
    changeLocale (loc) {
      this.$i18n.locale = loc
      this.$store.commit('main/setLocale', loc)
    },
    changeCurrency (curr) {
      this.$store.commit('main/setCurrency', curr)
    }
  },
  computed: {
    ...mapGetters({
      currency: 'main/currency',
      currencies: 'main/currencies',
      locale: 'main/locale',
      loggedUser: 'main/loggedUser',
      appName: 'main/appName'
    }),
    hideButtons: function () {
      if (['/activity-booking'].includes(this.$router.history.current.path)) {
        return true
      } else {
        return false
      }
    }
  },
  created () {
    if (this.currency == null) {
      this.$store.commit('main/setCurrency', this.currencies[0])
    }
  },
}
</script>

<style scoped>
/*header{
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  /*margin-bottom: 3rem !important;*/
/*}*/
header .logo {
  font-size: 1.5em;
  font-weight: 600;
}

header ul {
  position: relative;
  display: flex;
  align-items: center;
}

header ul li {
  list-style: none;
}

header ul li a {
  display: inline-block;
  margin-left: 20px;
  color: #333;
  text-decoration: none;
}

header .login {
  background: indigo;
  color: white;
  border: 1px solid transparent;
  border-radius: 40px;
  padding: 4px 15px;
  font-weight: 500;
}

header .login:hover {
  background: white;
  color: indigo;
  border: 1px solid indigo;
  transition: background .5s;
}

.v-menu {
  display: inline-block;
}
</style>
